if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        container: "[data-variant-picker]",
        productInfo: ".m-product-info--wrapper",
        error: ".m-product-form-message",
        variantIdInput: '[name="id"]',
        pickerFields: ["[data-picker-field]"],
        optionNodes: [".m-product-option--node"],
        productSku: "[data-variant-sku]",
        productAvailability: "[data-availability]",
        shareUrlInput: "[data-share-url]",
        stockCountdown: ".prod__stock-countdown",
        productWrapper: ".m-main-product--wrapper"
      };
      this.container = this.closest(this.selectors.container);
      this.productWrapper = this.closest(this.selectors.productWrapper);
      this.productInfo = this.closest(this.selectors.productInfo);
      this.domNodes = queryDomNodes(this.selectors, this.productInfo);
    }

    connectedCallback() {
      this.setupData();
    }

    async setupData() {
      let product = (window._themeProducts || {})[this.container.dataset.productId];
      this.productId = this.container.dataset.productId;
      this.sectionId = this.container.dataset.section;
      this.productUrl = this.container.dataset.productUrl;
      this.productHandle = this.container.dataset.productHandle;
      this.hasOnlyDefaultVariant = "true" === this.dataset.hasOnlyDefaultVariant;
      this.section = this.container.closest(`[data-section-id="${this.sectionId}"]`);
      this.variantData = this.getVariantData();
      this.productData = Object.assign(await this.getProductJson(), product);
      this.showFeaturedMedia = "true" === this.dataset.showFeaturedMedia;
      this.productForm = this.productWrapper.querySelector("product-form");

      const urlHasVariant = window.location.search.includes("?variant=");
      this.selectedVariantDefault = "true" === this.dataset.disableSelectedVariantDefault && 
        this.productData && 
        this.productData.variants.length > 1 && 
        !urlHasVariant;
      
      this.selectedVariantDefault && this.disableSelectedVariantDefault();
      
      this.enableVariantGroupImages = "true" === this.container.dataset.enableVariantGroupImages;
      this.enableVariantGroupImages && (this.variantGroupImages = this.getVariantGroupImageData());

      const variantId = this.productInfo.querySelector(this.selectors.variantIdInput).value;
      this.currentVariant = this.productData.variants.find(v => v.id === Number(variantId));
      this.productData.current_variant_id = this.currentVariant && this.currentVariant.id;
      this.productData.initialVariant = this.currentVariant;

      if (this.currentVariant) {
        this.getDataImageVariant(this.currentVariant.id);
        !this.disableSelectedVariantDefault && this.hideSoldOutAndUnavailableOptions();
        this.updateButton(!this.currentVariant.available, "", !1);
      }

      this.getMediaGallery();
      document.addEventListener("matchMobile", () => this.getMediaGallery());
      document.addEventListener("unmatchMobile", () => this.getMediaGallery());
      
      this.initOptionSwatches();
      this.addEventListener("change", this.onVariantChange);
    }

    disableSelectedVariantDefault() {
      const radios = this.querySelectorAll('input[type="radio"]');
      radios && radios.forEach(radio => radio.checked = !1);
      
      const radioFields = this.querySelectorAll("[data-picker-field='radio']");
      radioFields && radioFields.forEach(field => field.setAttribute("data-selected-value", ""));
      
      const selectFields = this.querySelectorAll("[data-picker-field='select']");
      selectFields && selectFields.forEach(field => {
        const select = field.querySelector("select");
        select && (select.value = "");
        field.setAttribute("data-selected-value", "");
      });
      
      const selectedLabels = this.querySelectorAll(".option-label--selected");
      selectedLabels && selectedLabels.forEach(label => label.textContent = "");
      
      const variantInput = this.productForm && this.productForm.querySelector("[name='id']");
      variantInput && !this.hasOnlyDefaultVariant && (variantInput.value = "");
    }

    getMediaGallery() {
      this.mediaGallery = this.section.querySelector("media-gallery");
      this.mediaGalleryMobile = this.section.querySelector("media-gallery-mobile");
      
      this.check = setInterval(() => {
        if (this.mediaGallery || this.mediaGalleryMobile) {
          clearInterval(this.check);
          
          if (MinimogTheme.config.mqlMobile) {
            const gallery = this.mediaGalleryMobile || this.mediaGallery;
            this.media = gallery;
            !this.slides && gallery.slider && (this.slides = gallery.slider.slides);
            gallery.navSlider && !this.slidesNav && (this.slidesNav = gallery.navSlider.slides);
          } else {
            this.media = this.mediaGallery;
            this.layout = this.mediaGallery.layout;
            if ("slider" === this.mediaGallery.mediaMode) {
              !this.slides && this.mediaGallery.slider && (this.slides = this.mediaGallery.slider.slides);
              this.mediaGallery.navSlider && !this.slidesNav && (this.slidesNav = this.mediaGallery.navSlider.slides);
            } else {
              this.mediaItems = this.mediaGallery.querySelectorAll(".m-product-media--item");
            }
          }
          
          if ((!this.showFeaturedMedia || this.enableVariantGroupImages && this.variantGroupImages.enable)) {
            this.updateMedia();
          }
        }
      }, 100);
    }

    onVariantChange() {
  this.getSelectedOptions();
  this.getSelectedVariant();
  this.updateButton(true, "", false); // Disable buttons while loading
  this.updatePickupAvailability();
  this.removeErrorMessage();
  
  if (this.currentVariant) {
    this.getDataImageVariant(this.currentVariant.id);
    this.updateMedia();
    this.updateBrowserHistory();
    this.updateVariantInput();
    this.updateProductMeta();
    this.updatePrice();
    
    if (!this.currentVariant.available) {
      // Only disable Add to Cart with sold out text, keep Buy Now disabled
      this.updateButton(true, window.MinimogStrings.soldOut, true);
      
      this.domNodes.optionNodes.forEach(node => {
        if (node.dataset.value === this.currentVariant.options[Number(node.dataset.optionPosition)-1]) {
          node.classList.add("option-selected-soldout");
          if (node.querySelector("label")) {
            node.querySelector("label").classList.add("option-selected-soldout-label");
          }
        }
      });
    } else {
      // Enable both buttons when variant is available
      this.updateButton(false, window.MinimogStrings.addToCart, false);
    }
    
    this.hideSoldOutAndUnavailableOptions();
  } else {
    // Disable both buttons when no variant is selected
    this.updateButton(true, "", true);
    this.setUnavailable();
  }
  
  window.MinimogEvents.emit(`${this.productId}__VARIANT_CHANGE`, this.currentVariant, this);
}

    getDataImageVariant(variantId) {
      const variantImage = this.variantGroupImages && 
        this.variantGroupImages.mapping.find(v => Number(v.id) === variantId);
      
      if (this.variantGroupImages && this.variantGroupImages.enable && variantImage) {
        this.currentVariantMedia = variantImage.media;
      }
    }

    getProductJson() {
      return fetch(`${this.productUrl}.js`)
        .then(response => {
          if (response.ok) return response.json();
          return JSON.parse(this.productWrapper.querySelector("#productData[type='application/json']").textContent);
        })
        .catch(() => {});
    }

    getSelectedVariant() {
      let variant = getVariantFromOptionArray(this.productData, this.options);
      let options = [...this.options];
      
      if (!variant) {
        if (!this.disableSelectedVariantDefault) options.pop();
        variant = getVariantFromOptionArray(this.productData, options);
        
        if (!variant) {
          if (!this.disableSelectedVariantDefault) options.pop();
          variant = getVariantFromOptionArray(this.productData, options);
        }
        
        this.options = [...variant.options];
        this.updateSelectedOptions();
      }
      
      this.currentVariant = variant;
    }

    getSelectedOptions() {
      const pickerFields = Array.from(this.querySelectorAll("[data-picker-field]"));
      this.options = pickerFields.map(field => {
        if ("radio" === field.dataset.pickerField) {
          const checkedRadio = Array.from(field.querySelectorAll("input")).find(input => input.checked);
          return checkedRadio ? checkedRadio.value : undefined;
        }
        return field.querySelector("select") ? field.querySelector("select").value : undefined;
      });
    }

    updateSelectedOptions() {
      this.domNodes.pickerFields.forEach((field, index) => {
        if (field.dataset.selectedValue !== this.options[index]) {
          const input = field.querySelector(`input[value="${this.options[index].replace(/["\\]/g, "\\$&")}"]`);
          if (input) {
            input.checked = true;
            field.updateSelectedValue();
          }
        }
      });
    }

    updateMedia() {
      if (!this.currentVariant) return;
      
      let slides = [], thumbs = [], slideIndex = 0, thumbIndex = 0;
      
      if (this.variantGroupImages && this.variantGroupImages.enable) {
        if ("slider" === this.media.mediaMode && this.slides) {
          this.slides.forEach(slide => {
            const mediaId = slide.querySelector("[data-media-id]").dataset.mediaId;
            
            if (this.currentVariantMedia && this.currentVariantMedia.length > 0) {
              if (this.currentVariantMedia.includes(mediaId)) {
                slide.dataset.swiperSlideIndex = slideIndex++;
                slide.dataset.index = thumbIndex++;
                if ("0" === slide.dataset.swiperSlideIndex) slide.classList.add("swiper-slide-active");
                slides.push(slide);
              }
              
              if (!slide.classList.contains("media-type-image")) {
                slide.dataset.swiperSlideIndex = slideIndex++;
                slide.dataset.index = thumbIndex++;
                slides.push(slide);
              }
            } else {
              slide.dataset.swiperSlideIndex = slideIndex++;
              slide.dataset.index = thumbIndex++;
              slides.push(slide);
            }
          });
          
          this.media.slider.removeAllSlides();
          this.media.slider.appendSlide(slides);
          this.media.slider.slideToLoop("layout-7" == this.layout ? 1 : 0);
          this.media.handleSlideChange();
          
          if (this.slidesNav) {
            this.slidesNav.forEach(thumb => {
              const mediaId = thumb.querySelector("[data-media-id]").dataset.mediaId;
              
              if (this.currentVariantMedia && this.currentVariantMedia.length > 0) {
                if (this.currentVariantMedia.includes(mediaId)) {
                  thumb.dataset.swiperSlideIndex = slideIndex++;
                  thumb.dataset.index = thumbIndex++;
                  if ("0" === thumb.dataset.swiperSlideIndex) thumb.classList.add("swiper-slide-thumb-active");
                  thumbs.push(thumb);
                }
                
                if (!thumb.classList.contains("media-type-image")) {
                  thumb.dataset.swiperSlideIndex = slideIndex++;
                  thumb.dataset.index = thumbIndex++;
                  thumbs.push(thumb);
                }
              } else {
                thumb.dataset.swiperSlideIndex = slideIndex++;
                thumb.dataset.index = thumbIndex++;
                if ("0" === thumb.dataset.swiperSlideIndex) thumb.classList.add("swiper-slide-thumb-active");
                thumbs.push(thumb);
              }
            });
            
            if (this.media.navSlider) {
              this.media.navSlider.removeAllSlides();
              this.media.navSlider.appendSlide(thumbs);
              this.media.navSlider.slideToLoop(0);
            }
          }
        }
        
        if (this.media) {
          this.media.removeAttribute("data-media-loading");
          this.media.firstElementChild.style.opacity = 1;
        }
      } else if (parseInt(this.media?.dataset.mediaSize) > 0) {
        this.media.setActiveMedia(this.currentVariant);
      }
      
      const lightboxItems = [];
      slides.forEach((slide, index) => {
        if ("image" === slide.dataset.mediaType) {
          const imgData = slide.querySelector(".m-product-media").dataset;
          lightboxItems.push({
            src: imgData.mediaSrc,
            width: parseInt(imgData.mediaWidth),
            height: parseInt(imgData.mediaHeight),
            alt: imgData.mediaAlt,
            id: slide.dataset.index
          });
        } else {
          lightboxItems.push({
            html: `<div class="pswp__${slide.dataset.mediaType}">${slide.innerHTML}</div>`,
            type: slide.dataset.mediaType,
            id: slide.dataset.index
          });
        }
      });
      
      if (this.media) {
        this.media.lightbox?.destroy();
        this.media.handlePhotoswipe(lightboxItems);
        this.media.initPhotoswipe();
      }
    }

    updateBrowserHistory() {
      if (this.currentVariant && "false" !== this.dataset.updateUrl) {
        window.history.replaceState({}, "", `${this.productUrl}?variant=${this.currentVariant.id}`);
      }
    }

    updateVariantInput() {
      document.querySelectorAll(`#product-form-${this.sectionId}, #product-form-installment`).forEach(form => {
        const input = form.querySelector(this.selectors.variantIdInput);
        if (input) {
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }

    updatePickupAvailability() {
      const pickup = this.section.querySelector("pickup-availability");
      if (pickup) {
        if (this.currentVariant && this.currentVariant.available) {
          pickup.fetchAvailability(this.currentVariant.id);
        } else {
          pickup.removeAttribute("available");
          pickup.innerHTML = "";
        }
      }
    }

    removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;
      
      const productForm = section.querySelector("product-form");
      productForm && productForm.handleErrorMessage();
    }

    updatePrice() {
      const priceBlock = this.productInfo.querySelector(".main-product__block-price");
      if (!priceBlock) return;
      
      const moneyFormat = window.MinimogSettings.money_format;
      const {
        priceWrapper,
        salePrice,
        unitPrice,
        compareAtPrice,
        saleBadge,
        saleAmount,
        unitPriceWrapper
      } = queryDomNodes({
        priceWrapper: ".m-price",
        salePrice: ".m-price-item--sale",
        compareAtPrice: [".m-price-item--regular"],
        unitPrice: ".m-price__unit",
        unitPriceWrapper: ".m-price__unit-wrapper",
        saleBadge: ".m-price__badge-sale",
        saleAmount: "[data-saved-price]"
      }, priceBlock);
      
      const {
        compare_at_price: comparePrice,
        price,
        unit_price_measurement: unitMeasurement
      } = this.currentVariant;
      
      const saleBadgeType = priceWrapper.dataset.saleBadgeType;
      const isOnSale = comparePrice && comparePrice > price;
      const isSoldOut = !this.currentVariant.available;
      
      // Update sale status
      if (isOnSale) {
        priceWrapper.classList.add("m-price--on-sale");
      } else {
        priceWrapper.classList.remove("m-price--on-sale");
      }
      
      // Update sold out status
      if (isSoldOut) {
        priceWrapper.classList.add("m-price--sold-out");
      } else {
        priceWrapper.classList.remove("m-price--sold-out");
      }
      
      priceWrapper?.classList.remove("visibility-hidden");
      
      // Update prices
      if (salePrice) {
        salePrice.innerHTML = formatMoney(price, moneyFormat);
      }
      
      if (compareAtPrice.length && isOnSale) {
        compareAtPrice.forEach(el => el.innerHTML = formatMoney(comparePrice, moneyFormat));
      } else {
        compareAtPrice.forEach(el => el.innerHTML = formatMoney(price, moneyFormat));
      }
      
      // Update sale badge
      if (saleBadge && isOnSale && "text" !== saleBadgeType) {
        let discountValue;
        
        if ("fixed_amount" === saleBadgeType) {
          discountValue = formatMoney(comparePrice - price, moneyFormat);
        } else {
          const discountPercent = 100 * (comparePrice - price) / comparePrice;
          discountValue = Math.round(discountPercent) + "%";
        }
        
        if (saleAmount) {
          saleAmount.innerHTML = discountValue;
        }
      }
      
      // Update unit price
      if (unitMeasurement && unitPrice) {
        unitPriceWrapper.classList.remove("m:hidden");
        const unitPriceHTML = `<span>${formatMoney(this.currentVariant.unit_price, moneyFormat)}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
        unitPrice.innerHTML = unitPriceHTML;
      } else {
        unitPriceWrapper?.classList.add("m:hidden");
      }
    }

    _getBaseUnit() {
      return this.currentVariant.unit_price_measurement.reference_value === 1
        ? this.currentVariant.unit_price_measurement.reference_unit
        : this.currentVariant.unit_price_measurement.reference_value + 
          this.currentVariant.unit_price_measurement.reference_unit;
    }

    updateButton(disabled = true, text, isUnavailable = false) {
  const forms = document.querySelectorAll(`.product-form-${this.sectionId}`);
  
  forms?.forEach(form => {
    // Handle Add to Cart button separately
    const addToCartButton = form.querySelector('[name="add"]');
    const dynamicCheckout = form.querySelector(".m-product-dynamic-checkout");
    const buttonText = form.querySelector('[name="add"] > .m-add-to-cart--text');
    
    // Handle Buy Now button separately if it exists
    const buyNowButton = form.querySelector('[name="buy-now"]');
    
    if (addToCartButton) {
      if (disabled) {
        addToCartButton.setAttribute("disabled", "disabled");
        addToCartButton.classList.add("disabled");
        dynamicCheckout?.classList.add("disabled");
        
        if (text) {
          buttonText.textContent = text;
        }
      } else {
        addToCartButton.removeAttribute("disabled");
        addToCartButton.classList.remove("disabled");
        dynamicCheckout?.classList.remove("disabled");
        buttonText.textContent = window.MinimogStrings.addToCart;
      }
    }
    
    // Only update Buy Now button if it exists and variant is available
    if (buyNowButton) {
      if (disabled || isUnavailable) {
        buyNowButton.setAttribute("disabled", "disabled");
        buyNowButton.classList.add("disabled");
      } else {
        buyNowButton.removeAttribute("disabled");
        buyNowButton.classList.remove("disabled");
      }
    }
  });
}

    updateProductMeta() {
      const { available, sku } = this.currentVariant;
      const { inStock, outOfStock } = window.MinimogStrings;
      
      const availabilityEl = this.section.querySelector(this.selectors.productAvailability);
      const skuEl = this.section.querySelector(this.selectors.productSku);
      
      if (skuEl) {
        skuEl.textContent = sku || "N/A";
      }
      
      if (availabilityEl) {
        const method = available ? "remove" : "add";
        availabilityEl.textContent = available ? inStock : outOfStock;
        availabilityEl.classList[method]("m-product-availability--outofstock");
      }
    }

    setUnavailable() {
      const form = document.getElementById(`product-form-${this.sectionId}`);
      const button = form?.querySelector('[name="add"]');
      const buttonText = form?.querySelector('[name="add"] > span.m-add-to-cart--text');
      const priceEl = this.section.querySelector(".m-price");
      
      if (button && buttonText) {
        buttonText.textContent = window.MinimogStrings.unavailable;
      }
      
      if (priceEl) {
        priceEl.classList.add("visibility-hidden");
      }
    }

    hideSoldOutAndUnavailableOptions() {
      const soldOutClass = "m-product-option--node__soldout";
      const unavailableClass = "m-product-option--node__unavailable";
      const currentVariant = this.currentVariant;
      const { optionNodes } = this.domNodes;
      const { productData, productData: { variants, options: { length: optionsCount } } } = this;
      
      optionNodes?.forEach(node => {
        const { optionPosition, value } = node.dataset;
        const position = Number(optionPosition);
        const isOptionElement = "OPTION" === node.tagName;
        let matchingVariants = [];
        
        if (position === optionsCount) {
          const options = Array.from(currentVariant.options);
          options[optionsCount - 1] = value;
          matchingVariants.push(getVariantFromOptionArray(productData, options));
        } else {
          matchingVariants = variants.filter(v => 
            v.options[position - 1] === value && 
            v.options[position - 2] === currentVariant[`option${position - 1}`]
          );
        }
        
        matchingVariants = matchingVariants.filter(Boolean);
        
        if (matchingVariants.length) {
          node.classList.remove(unavailableClass);
          isOptionElement && node.removeAttribute("disabled");
          
          // Apply sold out class if all matching variants are unavailable
          const method = matchingVariants.every(v => !v.available) ? "add" : "remove";
          node.classList[method](soldOutClass);
          
          // Hide completely unavailable options
          if (matchingVariants.length === 0) {
            node.classList.add(unavailableClass);
            node.style.opacity = "0.5";
            node.style.pointerEvents = "none";
          }
        } else {
          node.classList.add(unavailableClass);
          node.classList.add(soldOutClass);
          isOptionElement && node.setAttribute("disabled", "true");
          node.style.display = "none";
        }
      });
    }

    initOptionSwatches() {
      const { _colorSwatches = [], _imageSwatches = [] } = window.MinimogSettings;
      
      this.domNodes.optionNodes?.forEach(node => {
        const { optionType, optionPosition, value } = node.dataset;
        const valueLower = value.toLowerCase();
        const variant = this.variantData.find(v => v[`option${optionPosition}`] === value);
        
        const variantImage = variant?.featured_image?.src 
          ? getSizedImageUrl(variant.featured_image.src, "100x") 
          : null;
        
        const imageSwatch = _imageSwatches.find(s => s.key === valueLower)?.value || "";
        const colorSwatch = _colorSwatches.find(s => s.key === valueLower)?.value || "";
        
        // Check if this option has any available variants
        const hasAvailableVariants = this.productData.variants.some(v => 
          v.options[Number(optionPosition) - 1] === value && v.available
        );
        
        // Add sold-out class if no available variants
        if (!hasAvailableVariants) {
          node.classList.add("m-product-option--node__soldout");
          if (node.querySelector("label")) {
            node.querySelector("label").classList.add("option-soldout");
          }
        }
        
        // Apply swatch styles
        if (variantImage || imageSwatch) {
          node.querySelector("label")?.classList.add("has-bg-img");
        }
        
        switch (optionType) {
          case "default":
            node.querySelector("label").style.backgroundImage = `url(${imageSwatch || variantImage || ""})`;
            node.querySelector("label").classList.remove("option-loading");
            break;
            
          case "image":
            node.querySelector("label").style.backgroundImage = `url(${variantImage || imageSwatch || ""})`;
            node.querySelector("label").classList.remove("option-loading");
            break;
            
          case "color":
            node.querySelector("label").style.backgroundColor = colorSwatch || valueLower;
            if (imageSwatch) {
              node.querySelector("label").style.backgroundImage = `url(${imageSwatch})`;
            }
            node.querySelector("label").classList.remove("option-loading");
            break;
        }
      });
    }

    getVariantData() {
      return this.variantData = this.variantData || 
        JSON.parse(this.container.querySelector('#productVariants[type="application/json"]').textContent);
    }

    getVariantGroupImageData() {
      return this.variantGroupImages = this.variantGroupImages || 
        JSON.parse(this.container.querySelector('#variantGroup[type="application/json"]').textContent);
    }
  }

  customElements.define("variant-picker", VariantPicker);
}

// Variant button component remains unchanged
if (!customElements.get("variant-button")) {
  class VariantButton extends HTMLElement {
    constructor() {
      super();
      this.selectedSpan = this.querySelector(".option-label--selected");
      this.addEventListener("change", this.updateSelectedValue);
    }

    updateSelectedValue() {
      this.value = Array.from(this.querySelectorAll("input")).find(input => input.checked).value;
      this.setAttribute("data-selected-value", this.value);
      
      if (this.selectedSpan) {
        this.selectedSpan.textContent = this.value;
        this.selectedSpan.classList.remove("m:text-color-error");
      }
    }
  }

  customElements.define("variant-button", VariantButton);
}

// Variant select component remains unchanged
if (!customElements.get("variant-select")) {
  class VariantSelect extends VariantButton {
    constructor() {
      super();
    }

    updateSelectedValue() {
      this.value = this.querySelector("select").value;
      this.setAttribute("data-selected-value", this.value);
      
      if (this.selectedSpan) {
        this.selectedSpan.textContent = this.value;
        this.selectedSpan.classList.remove("m:text-color-error");
      }
    }
  }

  customElements.define("variant-select", VariantSelect);
}

// Variant image component remains unchanged
if (!customElements.get("variant-image")) {
  class VariantImage extends VariantButton {
    constructor() {
      super();
    }
  }

  customElements.define("variant-image", VariantImage);
}

// Variant color component remains unchanged
if (!customElements.get("variant-color")) {
  class VariantColor extends VariantButton {
    constructor() {
      super();
    }
  }

  customElements.define("variant-color", VariantColor);
}